<template>
  <div class="min-h-screen bg-bochas-bg flex items-center justify-center px-6">
    <div class="max-w-2xl w-full text-center py-20">
      <!-- Número 404 grande con el gradiente de marca -->
      <div
        class="inline-flex items-center justify-center mb-8 select-none"
        aria-hidden="true"
      >
        <span
          class="text-[8rem] sm:text-[10rem] md:text-[12rem] font-extrabold leading-none bg-degradado-bochas bg-clip-text text-transparent"
        >
          404
        </span>
      </div>

      <h1
        class="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white mb-4 leading-tight"
      >
        Página no encontrada
      </h1>
      <p
        class="text-base sm:text-lg text-bochas-text-muted mb-10 max-w-lg mx-auto"
      >
        La página que buscás no existe o fue movida. Volvé al inicio y seguí
        explorando la comunidad bochófila.
      </p>

      <div class="flex flex-col sm:flex-row gap-3 justify-center items-center">
        <router-link to="/" class="btn-bochas-rojo text-sm sm:text-base">
          Volver al inicio
        </router-link>
        <router-link
          to="/historias"
          class="btn-bochas-trans text-sm sm:text-base"
        >
          Ver historias
        </router-link>
      </div>

      <!-- Links secundarios -->
      <div
        class="mt-12 pt-8 border-t border-white/10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-bochas-text-muted"
      >
        <router-link
          to="/la-federacion"
          class="hover:text-white transition-colors"
        >
          La Federación
        </router-link>
        <span class="text-white/20">·</span>
        <router-link
          to="/noticias"
          class="hover:text-white transition-colors"
        >
          Novedades
        </router-link>
        <span class="text-white/20">·</span>
        <router-link
          to="/resultados"
          class="hover:text-white transition-colors"
        >
          Resultados
        </router-link>
        <span class="text-white/20">·</span>
        <router-link
          to="/calendario"
          class="hover:text-white transition-colors"
        >
          Calendario
        </router-link>
        <span class="text-white/20">·</span>
        <router-link
          to="/alojamiento"
          class="hover:text-white transition-colors"
        >
          Alojamiento
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
// Vista 404 — se renderiza cuándo la ruta no matchea ninguna otra.
// Se registra en el router con path: "*" (catch-all).
</script>
